import { api } from '@api/api2';
import { PropertyTypePayload } from './types';

const getPropertyTypes = (payload: PropertyTypePayload) =>
  api.v4('get', 'area/type/list', payload);

export const propertyTypesApi = { getPropertyTypes };
